import { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Collapse } from 'react-bootstrap'
import { SuccessAlert } from 'components/alerts'
import { InfoButton, LinkButton } from 'components/buttons'
import Link from 'components/link'
import { Checkbox, Form } from 'components/forms'
import Image from 'components/image'
import {
  bookmarksBarTitle,
  DraggableBookmarkButton,
  InstallInstructionsByBrowser,
} from 'shared/add-babylist-button'
import { saveUserEvent, setActiveModal } from 'registry/actions'
import { ADD_BABYLIST_BUTTON_EVENT, HELLO_BABY_BOX } from 'registry/constants'
import { getBabylistButtonAdded } from 'registry/reducers'

const AddBabylistButtonForm = (
  {
    babylistButtonAddedEvent,
    storeName,
    storeUrl,
    saveUserEvent,
    setActiveModal,
    isOpeningFromHBBGoalsModal,
  },
  context
) => {
  const [showInstructions] = useState(false)
  const { bookmarkletJS } = context
  const { register, setValue, getValues, watch } = useForm()

  const onSubmit = () => {
    saveUserEvent(ADD_BABYLIST_BUTTON_EVENT, getValues('addedBabylistButton'))
    const modalToOpen = isOpeningFromHBBGoalsModal ? HELLO_BABY_BOX : null
    setActiveModal(modalToOpen)
  }

  const installedButton = watch('addedBabylistButton', babylistButtonAddedEvent)

  return (
    <div style={{ overflow: 'hidden' }}>
      {installedButton && (
        <>
          <SuccessAlert className="mbl">
            You've installed the Babylist button! Now try it out!
          </SuccessAlert>
          {!!storeUrl && (
            <div className="text-center">
              <Link
                className="mbl btn btn-primary btn-pill"
                url={storeUrl}
                onClick={onSubmit}
                newWindow
              >
                Try it on {storeName}
              </Link>
            </div>
          )}
          <Image
            role="presentation"
            className="img-responsive mbl phm"
            src="https://images.babylist.com/image/upload/v1517531609/get_browser_button_email_gifonly_qpimjx.gif"
            lazyLoad={false}
          />
        </>
      )}

      <Collapse in={!installedButton || showInstructions}>
        <div>
          <p>The Babylist button lets you add items from any store.</p>
          <p>
            Drag the button below to your {bookmarksBarTitle()} bar to get
            started.
          </p>
          <DraggableBookmarkButton
            bookmarkletJS={bookmarkletJS}
            onInstall={() => setValue('addedBabylistButton', true)}
          />
          <div className="text-center">
            <LinkButton
              className="man pan"
              onClick={() => setValue('addedBabylistButton', true)}
            >
              I've added the Babylist button
            </LinkButton>
          </div>
          <hr className="mvl" />
          <InstallInstructionsByBrowser />
        </div>
      </Collapse>

      <Form className="mtm" onSubmit={onSubmit}>
        <Checkbox
          name="addedBabylistButton"
          inputRef={register}
          label="I've added the Babylist button"
          defaultChecked={babylistButtonAddedEvent}
        />
        <InfoButton block type="submit">
          Save
        </InfoButton>
      </Form>
    </div>
  )
}

AddBabylistButtonForm.propTypes = {
  babylistButtonAddedEvent: PropTypes.bool.isRequired,
  storeName: PropTypes.string,
  storeUrl: PropTypes.string,
  isOpeningFromHBBGoalsModal: PropTypes.bool,
  saveUserEvent: PropTypes.func.isRequired,
  setActiveModal: PropTypes.func.isRequired,
}

AddBabylistButtonForm.defaultProps = {
  storeName: null,
  storeUrl: null,
}

AddBabylistButtonForm.contextTypes = {
  bookmarkletJS: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    babylistButtonAddedEvent: getBabylistButtonAdded(state),
  }
}

export default connect(mapStateToProps, { saveUserEvent, setActiveModal })(
  AddBabylistButtonForm
)
